import {JSX} from "react";
import {MaterialIcon} from "../index";

export default function ValidationRequirement({text, checked}: { text: string, checked: boolean }): JSX.Element {
	return (
		<li className={"form-validation-requirement" + (checked ? " form-validation-checked" : "")}>
			<MaterialIcon icon="check_circle" />
			<span>{text}</span>
		</li>
	);
};
